import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { BrandMark } from "@/components/LogoUploader";
import { useBranding } from "@/lib/branding";

export const PublicLayout = ({ children, testid }) => {
  const { logo } = useBranding();
  return (
    <div className="min-h-screen bg-slate-100" data-testid={testid}>
      <header className="bg-[#020617]">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-5 py-4 sm:px-8">
          <Link to="/" data-testid="public-home-link" className="min-w-0"><BrandMark logo={logo} className="!max-h-8 !max-w-[170px] sm:!max-h-10 sm:!max-w-[260px]" /></Link>
          <div className="flex shrink-0 items-center gap-2">
            <Link to="/prova" data-testid="public-trial-link" className="rounded-md bg-sky-500 px-3 py-2 text-sm font-semibold text-[#020617] hover:bg-sky-400"><span className="sm:hidden">Prova</span><span className="hidden sm:inline">Prova gratis 30 giorni</span></Link>
            <Link to="/login" data-testid="public-login-link" className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-[#020617] hover:bg-slate-100">Accedi</Link>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-5 py-10 sm:px-8 sm:py-16">
        <Link to="/" className="mb-6 inline-flex items-center text-sm text-blue-700 hover:underline"><ArrowLeft className="mr-1 h-4 w-4" />Torna alla home</Link>
        {children}
      </main>
      <footer className="border-t border-slate-300 bg-white">
        <div className="mx-auto flex max-w-7xl flex-wrap justify-between gap-3 px-5 py-6 text-xs text-slate-600 sm:px-8">
          <span>© {new Date().getFullYear()} Generservice Srl Semplificata · P.IVA 07680350720</span>
          <span className="flex gap-4"><Link to="/privacy" className="hover:underline">Privacy</Link><Link to="/cookie" className="hover:underline">Cookie</Link><Link to="/termini" className="hover:underline">Termini</Link></span>
        </div>
      </footer>
    </div>
  );
};
